import { requestGet, requestPost, requestPut } from "../config/Api";

const base = "operation/type";

export const getOperationTypes = () => requestGet(base);

export const syncOperationTypes = () => requestPost(`${base}/sync`);

export const updateSentenceMarkers = (operationTypeIds) =>
  requestPut(`${base}/sentence-markers`, { operation_type_ids: operationTypeIds });
